import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type AccommodationsConsolePropertiesQueryVariables = Types.Exact<{
  payload: Types.AccommodationContentSearchInput;
}>;

export type AccommodationsConsolePropertiesQuery = {
  __typename?: 'Query';
  searchAccommodationProperties: {
    __typename?: 'AccommodationContentSearchResult';
    properties: Array<{
      __typename?: 'AccommodationCatalogProperty';
      joyPlaceId: string;
      name: string;
      propertyType: Types.AccommodationCatalogPropertyType;
      accommodationCategory?: Types.AccommodationCategory | null;
      chain?: string | null;
      starRating?: number | null;
      url?: string | null;
      id: string;
      facilities: Array<{ __typename?: 'AccommodationCatalogFacilityOrAmenity'; label: string }>;
      location: { __typename?: 'AccommodationCatalogLocation'; latitude?: number | null; longitude?: number | null };
      address?: {
        __typename?: 'AccommodationCatalogPropertyAddress';
        city?: string | null;
        country?: string | null;
        postalCode?: string | null;
        state?: string | null;
        street?: string | null;
      } | null;
      photos: Array<{ __typename?: 'AccommodationCatalogPhoto'; url: string; photo?: { __typename?: 'Photo'; id: string; assetId: string } | null }>;
      userRating?: { __typename?: 'UserRating'; ratingCount?: number | null; ratingValue?: number | null } | null;
    }>;
  };
};

export type AccommodationConsoleListingPricingFragment = {
  __typename?: 'PricingForAccommodationPlace';
  nightlyBaseRate: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; digits: number; currency: Types.TravelCurrencyCode };
  perNightPerOccupancyBaseAmount?: {
    __typename?: 'TravelMonetaryValue';
    floatingPointDecimalString: string;
    valueInMinorUnits: number;
    digits: number;
    currency: Types.TravelCurrencyCode;
  } | null;
  perNightPerOccupancyStrikeoutBaseAmount?: {
    __typename?: 'TravelMonetaryValue';
    floatingPointDecimalString: string;
    valueInMinorUnits: number;
    digits: number;
    currency: Types.TravelCurrencyCode;
  } | null;
  strikeoutNightlyBaseRate?: {
    __typename?: 'TravelMonetaryValue';
    floatingPointDecimalString: string;
    valueInMinorUnits: number;
    digits: number;
    currency: Types.TravelCurrencyCode;
  } | null;
  strikeoutTotalRate?: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; currency: Types.TravelCurrencyCode } | null;
  totalRate: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; digits: number; currency: Types.TravelCurrencyCode };
  cancellationPolicies?: Array<{
    __typename?: 'TravelOfferCancellationPolicyRule';
    start: string;
    end?: string | null;
    estimatedCancellationAmount?: {
      __typename?: 'TravelOfferEstimatedCancellationAmount';
      valueType: Types.TravelOfferCancellationPolicyRuleValueType;
      amount: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; digits: number; currency: Types.TravelCurrencyCode };
    } | null;
  }> | null;
};

export type AccommodationConsoleListingPropertyFragment = {
  __typename?: 'AccommodationCatalogProperty';
  joyPlaceId: string;
  name: string;
  propertyType: Types.AccommodationCatalogPropertyType;
  accommodationCategory?: Types.AccommodationCategory | null;
  chain?: string | null;
  starRating?: number | null;
  url?: string | null;
  id: string;
  facilities: Array<{ __typename?: 'AccommodationCatalogFacilityOrAmenity'; label: string }>;
  location: { __typename?: 'AccommodationCatalogLocation'; latitude?: number | null; longitude?: number | null };
  address?: {
    __typename?: 'AccommodationCatalogPropertyAddress';
    city?: string | null;
    country?: string | null;
    postalCode?: string | null;
    state?: string | null;
    street?: string | null;
  } | null;
  photos: Array<{ __typename?: 'AccommodationCatalogPhoto'; url: string; photo?: { __typename?: 'Photo'; id: string; assetId: string } | null }>;
  userRating?: { __typename?: 'UserRating'; ratingCount?: number | null; ratingValue?: number | null } | null;
};

export type AccommodationPlacesByCoupleQueryVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;

export type AccommodationPlacesByCoupleQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename: 'Event';
    id: string;
    travelSettings?: { __typename?: 'TravelSettings'; currencyCode?: Types.TravelCurrencyCode | null } | null;
    accommodationPlacesV2: Array<{
      __typename?: 'AccommodationPlaceV2';
      id: string;
      joyPlaceId?: string | null;
      isFromAccommodationCatalog: boolean;
      isFavorite?: boolean | null;
      isHostStayingHere?: boolean | null;
      userNote?: string | null;
      phone?: string | null;
      lat?: number | null;
      long?: number | null;
      name?: string | null;
      customName?: string | null;
      address?: string | null;
      city?: string | null;
      country?: string | null;
      postalCode?: string | null;
      state?: string | null;
      starRating?: number | null;
      url?: string | null;
      description?: string | null;
      type?: Types.AccommodationPlaceType | null;
      photo?: { __typename?: 'Photo'; id: string; url: string } | null;
      customPhoto?: { __typename?: 'Photo'; id: string; url: string } | null;
      accommodationRoomBlock?: {
        __typename?: 'AccommodationPlaceRoomBlock';
        bookingUrl: string;
        checkInDate: string;
        checkOutDate: string;
        cutoffDate: string;
        currencyCode?: string | null;
        isJoyManagedRoomBlock: boolean;
        numberOfRoomsReserved: number;
        interestedGuestCount: number;
        status: Types.AccommodationPlaceRoomBlockStatus;
        pricePerNight?: number | null;
        strikeoutPricePerNight?: number | null;
      } | null;
    }>;
  } | null;
};

export type AccommodationsConsoleStateInitializationQueryVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;

export type AccommodationsConsoleStateInitializationQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    travelSettings?: { __typename?: 'TravelSettings'; checkInDate?: string | null; checkOutDate?: string | null } | null;
    info: { __typename?: 'EventInfo'; id: string; finalizedDate?: { __typename?: 'Date'; dateString: string } | null };
    bestLocationAnchor?: { __typename?: 'LocationAnchor'; friendlyName: string; latitude: string; longitude: string; source: Types.LocationAnchorSource } | null;
  } | null;
};

export type AccommodationCatalogConsoleListingPropertyFragment = {
  __typename?: 'ExtendedAccommodationCatalogProperty';
  joyPlaceId: string;
  name: string;
  propertyType: Types.AccommodationCatalogPropertyType;
  accommodationCategory?: Types.AccommodationCategory | null;
  otaProvider: string;
  chain?: string | null;
  starRating?: number | null;
  url?: string | null;
  id: string;
  facilities: Array<{ __typename?: 'AccommodationCatalogFacilityOrAmenity'; label: string }>;
  location: { __typename?: 'AccommodationCatalogLocation'; latitude?: number | null; longitude?: number | null };
  address?: {
    __typename?: 'AccommodationCatalogPropertyAddress';
    city?: string | null;
    country?: string | null;
    postalCode?: string | null;
    state?: string | null;
    street?: string | null;
  } | null;
  photos: Array<{ __typename?: 'AccommodationCatalogPhoto'; url: string; photo?: { __typename?: 'Photo'; id: string; assetId: string } | null }>;
  userRating?: { __typename?: 'UserRating'; ratingCount?: number | null; ratingValue?: number | null } | null;
};

export type AccommodationCatalogConsoleListingRedirectMechanismsFragment = {
  __typename?: 'RedirectMechanism';
  type: Types.RedirectMechanismType;
  url: string;
  telemetryDestinationName: string;
  trackingQueryStringKey?: Types.TrackingQueryStringKey | null;
};

export type AccommodationCatalogConsoleListingPricingFragment = {
  __typename?: 'AccommodationCatalogPropertyPricingInfo';
  _diag?: any | null;
  nightlyBaseRate: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; digits: number; currency: Types.TravelCurrencyCode };
  perNightPerOccupancyBaseAmount?: {
    __typename?: 'TravelMonetaryValue';
    floatingPointDecimalString: string;
    valueInMinorUnits: number;
    digits: number;
    currency: Types.TravelCurrencyCode;
  } | null;
  perNightPerOccupancyStrikeoutBaseAmount?: {
    __typename?: 'TravelMonetaryValue';
    floatingPointDecimalString: string;
    valueInMinorUnits: number;
    digits: number;
    currency: Types.TravelCurrencyCode;
  } | null;
  strikeoutNightlyBaseRate?: {
    __typename?: 'TravelMonetaryValue';
    floatingPointDecimalString: string;
    valueInMinorUnits: number;
    digits: number;
    currency: Types.TravelCurrencyCode;
  } | null;
  strikeoutTotalRate?: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; currency: Types.TravelCurrencyCode } | null;
  totalRate: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; digits: number; currency: Types.TravelCurrencyCode };
  cancellationPolicies?: Array<{
    __typename?: 'TravelOfferCancellationPolicyRule';
    start: string;
    end?: string | null;
    estimatedCancellationAmount?: {
      __typename?: 'TravelOfferEstimatedCancellationAmount';
      valueType: Types.TravelOfferCancellationPolicyRuleValueType;
      amount: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; digits: number; currency: Types.TravelCurrencyCode };
    } | null;
  }> | null;
};

export type AccommodationsConsolePropertiesV2QueryVariables = Types.Exact<{
  payload: Types.SearchExtendedAccommodationPropertiesV2Payload;
}>;

export type AccommodationsConsolePropertiesV2Query = {
  __typename?: 'Query';
  searchExtendedAccommodationProperties: {
    __typename?: 'ExtendedAccommodationContentSearchResult';
    properties: Array<{
      __typename?: 'ExtendedAccommodationCatalogProperty';
      score: number;
      isSponsored?: boolean | null;
      joyPlaceId: string;
      name: string;
      propertyType: Types.AccommodationCatalogPropertyType;
      accommodationCategory?: Types.AccommodationCategory | null;
      otaProvider: string;
      chain?: string | null;
      starRating?: number | null;
      url?: string | null;
      id: string;
      pricingInfo?: {
        __typename?: 'AccommodationCatalogPropertyPricingInfo';
        _diag?: any | null;
        nightlyBaseRate: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; digits: number; currency: Types.TravelCurrencyCode };
        perNightPerOccupancyBaseAmount?: {
          __typename?: 'TravelMonetaryValue';
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
          digits: number;
          currency: Types.TravelCurrencyCode;
        } | null;
        perNightPerOccupancyStrikeoutBaseAmount?: {
          __typename?: 'TravelMonetaryValue';
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
          digits: number;
          currency: Types.TravelCurrencyCode;
        } | null;
        strikeoutNightlyBaseRate?: {
          __typename?: 'TravelMonetaryValue';
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
          digits: number;
          currency: Types.TravelCurrencyCode;
        } | null;
        strikeoutTotalRate?: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; currency: Types.TravelCurrencyCode } | null;
        totalRate: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; digits: number; currency: Types.TravelCurrencyCode };
        cancellationPolicies?: Array<{
          __typename?: 'TravelOfferCancellationPolicyRule';
          start: string;
          end?: string | null;
          estimatedCancellationAmount?: {
            __typename?: 'TravelOfferEstimatedCancellationAmount';
            valueType: Types.TravelOfferCancellationPolicyRuleValueType;
            amount: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; digits: number; currency: Types.TravelCurrencyCode };
          } | null;
        }> | null;
      } | null;
      redirectMechanisms?: Array<{
        __typename?: 'RedirectMechanism';
        type: Types.RedirectMechanismType;
        url: string;
        telemetryDestinationName: string;
        trackingQueryStringKey?: Types.TrackingQueryStringKey | null;
      }> | null;
      facilities: Array<{ __typename?: 'AccommodationCatalogFacilityOrAmenity'; label: string }>;
      location: { __typename?: 'AccommodationCatalogLocation'; latitude?: number | null; longitude?: number | null };
      address?: {
        __typename?: 'AccommodationCatalogPropertyAddress';
        city?: string | null;
        country?: string | null;
        postalCode?: string | null;
        state?: string | null;
        street?: string | null;
      } | null;
      photos: Array<{ __typename?: 'AccommodationCatalogPhoto'; url: string; photo?: { __typename?: 'Photo'; id: string; assetId: string } | null }>;
      userRating?: { __typename?: 'UserRating'; ratingCount?: number | null; ratingValue?: number | null } | null;
    }>;
  };
};

export type AccommodationsConsoleHotelsSortOrderQueryVariables = Types.Exact<{
  payload: Types.PageContainerBySlugPayload;
}>;

export type AccommodationsConsoleHotelsSortOrderQuery = {
  __typename?: 'Query';
  pageContainerBySlug?: {
    __typename?: 'PageContainer';
    id: string;
    components?: Array<
      | { __typename?: 'EventCountdownComponent' }
      | { __typename?: 'EventDetailsComponent' }
      | { __typename?: 'EventDisplayNameComponent' }
      | { __typename?: 'GreetingMessageComponent' }
      | { __typename?: 'JsonDataBlobComponent' }
      | { __typename?: 'MediaGalleryComponent' }
      | { __typename?: 'PhotoComponent' }
      | { __typename?: 'RsvpAndUnlockGuestDetailsButtonComponent' }
      | { __typename?: 'TextComponent' }
      | { __typename?: 'TravelMapComponent'; id: string; type: Types.ComponentType; sortOrder: number; blockOrdering?: Array<string> | null }
      | { __typename?: 'VideoComponent' }
    > | null;
  } | null;
};

export type AccommodationPlacesPricingAndBookingDetailsQueryVariables = Types.Exact<{
  payload: Types.TravelPlacePricingAndBookingDetailsPayload;
}>;

export type AccommodationPlacesPricingAndBookingDetailsQuery = {
  __typename?: 'Query';
  travelPlacesPricingAndBookingDetails: {
    __typename?: 'TravelPlacePricingAndBookingDetailsResult';
    accommodationPlaces: Array<{
      __typename: 'AccommodationPlacePricingAndBookingDetails';
      pricingInfo?: {
        __typename?: 'PricingForAccommodationPlace';
        strikeoutRateProvider?: Types.StrikeoutRateProvider | null;
        _diag?: any | null;
        baseRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
        nightlyBaseRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
        perNightPerOccupancyBaseAmount?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        nightlyTotalRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
        strikeoutBaseRate?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        strikeoutNightlyBaseRate?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        perNightPerOccupancyStrikeoutBaseAmount?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        strikeoutNightlyTotalRate?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        strikeoutTotalRate?: {
          __typename?: 'TravelMonetaryValue';
          currency: Types.TravelCurrencyCode;
          digits: number;
          floatingPointDecimalString: string;
          valueInMinorUnits: number;
        } | null;
        totalRate: { __typename?: 'TravelMonetaryValue'; currency: Types.TravelCurrencyCode; digits: number; floatingPointDecimalString: string; valueInMinorUnits: number };
        cancellationPolicies?: Array<{
          __typename?: 'TravelOfferCancellationPolicyRule';
          start: string;
          end?: string | null;
          estimatedCancellationAmount?: {
            __typename?: 'TravelOfferEstimatedCancellationAmount';
            valueType: Types.TravelOfferCancellationPolicyRuleValueType;
            amount: { __typename?: 'TravelMonetaryValue'; floatingPointDecimalString: string; valueInMinorUnits: number; digits: number; currency: Types.TravelCurrencyCode };
          } | null;
        }> | null;
      } | null;
      accommodationPlace: {
        __typename: 'AccommodationPlaceV2';
        id: string;
        lat?: number | null;
        long?: number | null;
        googlePlaceId?: string | null;
        joyPlaceId?: string | null;
        name?: string | null;
        address?: string | null;
        zhId?: string | null;
        url?: string | null;
        customUrl?: string | null;
        starRating?: number | null;
        photo?: { __typename?: 'Photo'; id: string; url: string } | null;
      };
      redirectMechanisms?: Array<{
        __typename: 'RedirectMechanism';
        telemetryDestinationName: string;
        trackingQueryStringKey?: Types.TrackingQueryStringKey | null;
        type: Types.RedirectMechanismType;
        url: string;
      }> | null;
    }>;
  };
};

export const AccommodationConsoleListingPricingFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationConsoleListingPricing' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PricingForAccommodationPlace' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nightlyBaseRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'perNightPerOccupancyBaseAmount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'perNightPerOccupancyStrikeoutBaseAmount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'strikeoutNightlyBaseRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'strikeoutTotalRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'estimatedCancellationAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AccommodationConsoleListingPropertyFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationConsoleListingProperty' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationCatalogProperty' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accommodationCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'chain' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facilities' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'label' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userRating' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserRating' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserRating' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UserRating' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ratingCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratingValue' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AccommodationCatalogConsoleListingPropertyFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationCatalogConsoleListingProperty' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExtendedAccommodationCatalogProperty' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accommodationCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'otaProvider' } },
          { kind: 'Field', name: { kind: 'Name', value: 'chain' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facilities' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'label' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userRating' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserRating' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserRating' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UserRating' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ratingCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratingValue' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AccommodationCatalogConsoleListingRedirectMechanismsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationCatalogConsoleListingRedirectMechanisms' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RedirectMechanism' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telemetryDestinationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'trackingQueryStringKey' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AccommodationCatalogConsoleListingPricingFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationCatalogConsoleListingPricing' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationCatalogPropertyPricingInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nightlyBaseRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'perNightPerOccupancyBaseAmount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'perNightPerOccupancyStrikeoutBaseAmount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'strikeoutNightlyBaseRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'strikeoutTotalRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'estimatedCancellationAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: '_diag' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AccommodationsConsolePropertiesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccommodationsConsoleProperties' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationContentSearchInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchAccommodationProperties' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'properties' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationConsoleListingProperty' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationConsoleListingProperty' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationCatalogProperty' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accommodationCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'chain' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facilities' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'label' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userRating' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserRating' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserRating' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UserRating' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ratingCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratingValue' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAccommodationsConsolePropertiesQuery__
 *
 * To run a query within a React component, call `useAccommodationsConsolePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationsConsolePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationsConsolePropertiesQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAccommodationsConsolePropertiesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationsConsolePropertiesQuery, AccommodationsConsolePropertiesQueryVariables>,
) {
  return ApolloReactHooks.useQuery<AccommodationsConsolePropertiesQuery, AccommodationsConsolePropertiesQueryVariables>(AccommodationsConsolePropertiesDocument, baseOptions);
}
export function useAccommodationsConsolePropertiesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationsConsolePropertiesQuery, AccommodationsConsolePropertiesQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<AccommodationsConsolePropertiesQuery, AccommodationsConsolePropertiesQueryVariables>(AccommodationsConsolePropertiesDocument, baseOptions);
}
export type AccommodationsConsolePropertiesQueryHookResult = ReturnType<typeof useAccommodationsConsolePropertiesQuery>;
export type AccommodationsConsolePropertiesLazyQueryHookResult = ReturnType<typeof useAccommodationsConsolePropertiesLazyQuery>;
export type AccommodationsConsolePropertiesQueryResult = Apollo.QueryResult<AccommodationsConsolePropertiesQuery, AccommodationsConsolePropertiesQueryVariables>;
export const AccommodationPlacesByCoupleDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccommodationPlacesByCouple' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'travelSettings' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accommodationPlacesV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isFromAccommodationCatalog' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isFavorite' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isHostStayingHere' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userNote' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'customName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customPhoto' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accommodationRoomBlock' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'bookingUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cutoffDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isJoyManagedRoomBlock' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'numberOfRoomsReserved' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'interestedGuestCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pricePerNight' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'strikeoutPricePerNight' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAccommodationPlacesByCoupleQuery__
 *
 * To run a query within a React component, call `useAccommodationPlacesByCoupleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationPlacesByCoupleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationPlacesByCoupleQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAccommodationPlacesByCoupleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationPlacesByCoupleQuery, AccommodationPlacesByCoupleQueryVariables>) {
  return ApolloReactHooks.useQuery<AccommodationPlacesByCoupleQuery, AccommodationPlacesByCoupleQueryVariables>(AccommodationPlacesByCoupleDocument, baseOptions);
}
export function useAccommodationPlacesByCoupleLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationPlacesByCoupleQuery, AccommodationPlacesByCoupleQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<AccommodationPlacesByCoupleQuery, AccommodationPlacesByCoupleQueryVariables>(AccommodationPlacesByCoupleDocument, baseOptions);
}
export type AccommodationPlacesByCoupleQueryHookResult = ReturnType<typeof useAccommodationPlacesByCoupleQuery>;
export type AccommodationPlacesByCoupleLazyQueryHookResult = ReturnType<typeof useAccommodationPlacesByCoupleLazyQuery>;
export type AccommodationPlacesByCoupleQueryResult = Apollo.QueryResult<AccommodationPlacesByCoupleQuery, AccommodationPlacesByCoupleQueryVariables>;
export const AccommodationsConsoleStateInitializationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccommodationsConsoleStateInitialization' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'travelSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalizedDate' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'dateString' } }] },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bestLocationAnchor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'friendlyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAccommodationsConsoleStateInitializationQuery__
 *
 * To run a query within a React component, call `useAccommodationsConsoleStateInitializationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationsConsoleStateInitializationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationsConsoleStateInitializationQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAccommodationsConsoleStateInitializationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationsConsoleStateInitializationQuery, AccommodationsConsoleStateInitializationQueryVariables>,
) {
  return ApolloReactHooks.useQuery<AccommodationsConsoleStateInitializationQuery, AccommodationsConsoleStateInitializationQueryVariables>(
    AccommodationsConsoleStateInitializationDocument,
    baseOptions,
  );
}
export function useAccommodationsConsoleStateInitializationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationsConsoleStateInitializationQuery, AccommodationsConsoleStateInitializationQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<AccommodationsConsoleStateInitializationQuery, AccommodationsConsoleStateInitializationQueryVariables>(
    AccommodationsConsoleStateInitializationDocument,
    baseOptions,
  );
}
export type AccommodationsConsoleStateInitializationQueryHookResult = ReturnType<typeof useAccommodationsConsoleStateInitializationQuery>;
export type AccommodationsConsoleStateInitializationLazyQueryHookResult = ReturnType<typeof useAccommodationsConsoleStateInitializationLazyQuery>;
export type AccommodationsConsoleStateInitializationQueryResult = Apollo.QueryResult<
  AccommodationsConsoleStateInitializationQuery,
  AccommodationsConsoleStateInitializationQueryVariables
>;
export const AccommodationsConsolePropertiesV2Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccommodationsConsolePropertiesV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchExtendedAccommodationPropertiesV2Payload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'searchExtendedAccommodationProperties' },
            name: { kind: 'Name', value: 'searchExtendedAccommodationPropertiesV2' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'properties' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationCatalogConsoleListingProperty' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSponsored' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricingInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationCatalogConsoleListingPricing' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'redirectMechanisms' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationCatalogConsoleListingRedirectMechanisms' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationCatalogConsoleListingProperty' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExtendedAccommodationCatalogProperty' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accommodationCategory' } },
          { kind: 'Field', name: { kind: 'Name', value: 'otaProvider' } },
          { kind: 'Field', name: { kind: 'Name', value: 'chain' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facilities' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'label' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userRating' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'UserRating' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationCatalogConsoleListingRedirectMechanisms' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RedirectMechanism' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telemetryDestinationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'trackingQueryStringKey' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationCatalogConsoleListingPricing' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationCatalogPropertyPricingInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nightlyBaseRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'perNightPerOccupancyBaseAmount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'perNightPerOccupancyStrikeoutBaseAmount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'strikeoutNightlyBaseRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'strikeoutTotalRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'estimatedCancellationAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: '_diag' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserRating' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UserRating' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'ratingCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ratingValue' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAccommodationsConsolePropertiesV2Query__
 *
 * To run a query within a React component, call `useAccommodationsConsolePropertiesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationsConsolePropertiesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationsConsolePropertiesV2Query({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAccommodationsConsolePropertiesV2Query(
  baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationsConsolePropertiesV2Query, AccommodationsConsolePropertiesV2QueryVariables>,
) {
  return ApolloReactHooks.useQuery<AccommodationsConsolePropertiesV2Query, AccommodationsConsolePropertiesV2QueryVariables>(AccommodationsConsolePropertiesV2Document, baseOptions);
}
export function useAccommodationsConsolePropertiesV2LazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationsConsolePropertiesV2Query, AccommodationsConsolePropertiesV2QueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<AccommodationsConsolePropertiesV2Query, AccommodationsConsolePropertiesV2QueryVariables>(
    AccommodationsConsolePropertiesV2Document,
    baseOptions,
  );
}
export type AccommodationsConsolePropertiesV2QueryHookResult = ReturnType<typeof useAccommodationsConsolePropertiesV2Query>;
export type AccommodationsConsolePropertiesV2LazyQueryHookResult = ReturnType<typeof useAccommodationsConsolePropertiesV2LazyQuery>;
export type AccommodationsConsolePropertiesV2QueryResult = Apollo.QueryResult<AccommodationsConsolePropertiesV2Query, AccommodationsConsolePropertiesV2QueryVariables>;
export const AccommodationsConsoleHotelsSortOrderDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccommodationsConsoleHotelsSortOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageContainerBySlugPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageContainerBySlug' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'components' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelMapComponent' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'blockOrdering' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAccommodationsConsoleHotelsSortOrderQuery__
 *
 * To run a query within a React component, call `useAccommodationsConsoleHotelsSortOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationsConsoleHotelsSortOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationsConsoleHotelsSortOrderQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAccommodationsConsoleHotelsSortOrderQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationsConsoleHotelsSortOrderQuery, AccommodationsConsoleHotelsSortOrderQueryVariables>,
) {
  return ApolloReactHooks.useQuery<AccommodationsConsoleHotelsSortOrderQuery, AccommodationsConsoleHotelsSortOrderQueryVariables>(
    AccommodationsConsoleHotelsSortOrderDocument,
    baseOptions,
  );
}
export function useAccommodationsConsoleHotelsSortOrderLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationsConsoleHotelsSortOrderQuery, AccommodationsConsoleHotelsSortOrderQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<AccommodationsConsoleHotelsSortOrderQuery, AccommodationsConsoleHotelsSortOrderQueryVariables>(
    AccommodationsConsoleHotelsSortOrderDocument,
    baseOptions,
  );
}
export type AccommodationsConsoleHotelsSortOrderQueryHookResult = ReturnType<typeof useAccommodationsConsoleHotelsSortOrderQuery>;
export type AccommodationsConsoleHotelsSortOrderLazyQueryHookResult = ReturnType<typeof useAccommodationsConsoleHotelsSortOrderLazyQuery>;
export type AccommodationsConsoleHotelsSortOrderQueryResult = Apollo.QueryResult<AccommodationsConsoleHotelsSortOrderQuery, AccommodationsConsoleHotelsSortOrderQueryVariables>;
export const AccommodationPlacesPricingAndBookingDetailsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccommodationPlacesPricingAndBookingDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelPlacePricingAndBookingDetailsPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelPlacesPricingAndBookingDetails' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accommodationPlaces' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TravelPlacePricingAndBookingDetails' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pricingInfo' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccommodationConsoleListingPricing' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccommodationConsoleListingPricing' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PricingForAccommodationPlace' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nightlyBaseRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'perNightPerOccupancyBaseAmount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'perNightPerOccupancyStrikeoutBaseAmount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'strikeoutNightlyBaseRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'strikeoutTotalRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'totalRate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'estimatedCancellationAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelPlacePricingAndBookingDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationPlacePricingAndBookingDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accommodationPlace' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zhId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'starRating' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pricingInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'baseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nightlyBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perNightPerOccupancyBaseAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nightlyTotalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strikeoutBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strikeoutNightlyBaseRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'perNightPerOccupancyStrikeoutBaseAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strikeoutNightlyTotalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'strikeoutRateProvider' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strikeoutTotalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalRate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'digits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '_diag' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'redirectMechanisms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telemetryDestinationName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingQueryStringKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAccommodationPlacesPricingAndBookingDetailsQuery__
 *
 * To run a query within a React component, call `useAccommodationPlacesPricingAndBookingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccommodationPlacesPricingAndBookingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccommodationPlacesPricingAndBookingDetailsQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAccommodationPlacesPricingAndBookingDetailsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<AccommodationPlacesPricingAndBookingDetailsQuery, AccommodationPlacesPricingAndBookingDetailsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<AccommodationPlacesPricingAndBookingDetailsQuery, AccommodationPlacesPricingAndBookingDetailsQueryVariables>(
    AccommodationPlacesPricingAndBookingDetailsDocument,
    baseOptions,
  );
}
export function useAccommodationPlacesPricingAndBookingDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccommodationPlacesPricingAndBookingDetailsQuery, AccommodationPlacesPricingAndBookingDetailsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<AccommodationPlacesPricingAndBookingDetailsQuery, AccommodationPlacesPricingAndBookingDetailsQueryVariables>(
    AccommodationPlacesPricingAndBookingDetailsDocument,
    baseOptions,
  );
}
export type AccommodationPlacesPricingAndBookingDetailsQueryHookResult = ReturnType<typeof useAccommodationPlacesPricingAndBookingDetailsQuery>;
export type AccommodationPlacesPricingAndBookingDetailsLazyQueryHookResult = ReturnType<typeof useAccommodationPlacesPricingAndBookingDetailsLazyQuery>;
export type AccommodationPlacesPricingAndBookingDetailsQueryResult = Apollo.QueryResult<
  AccommodationPlacesPricingAndBookingDetailsQuery,
  AccommodationPlacesPricingAndBookingDetailsQueryVariables
>;
